var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m291.135 278.507a48.544 48.544 0 1 0 -48.544 48.544 48.543 48.543 0 0 0 48.544-48.544z",
    fill: "#feb69e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.961 348.74h-48.738a60.762 60.762 0 0 0 -60.584 60.584v12.376h169.9v-12.376a60.762 60.762 0 0 0 -60.578-60.584z",
    fill: "#3abeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.926 421.7h16v-11.219a8 8 0 0 0 -16 0z",
    fill: "#2f9acf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.256 421.7h16v-11.219a8 8 0 0 0 -16 0z",
    fill: "#2f9acf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.748 352.514 26.164 15.106 26.164 15.105a6.334 6.334 0 0 0 3.5.874l1.916-69.128-60.084-31.171a6.361 6.361 0 0 0 -.859 3.248v60.423a6.249 6.249 0 0 0 3.199 5.543z",
    fill: "#a67e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.408 283.3 60.08 31.169 55.669-31.143a6.379 6.379 0 0 0 -2.356-2.318l-26.164-15.108-26.163-15.1a6.251 6.251 0 0 0 -6.4 0l-14.111 8.147-12.051 6.953-26.164 15.11a6.366 6.366 0 0 0 -2.34 2.29z",
    fill: "#f2d3ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.488 314.471-1.916 69.129a6.41 6.41 0 0 0 2.9-.874l26.163-15.105 26.165-15.107a6.249 6.249 0 0 0 3.2-5.541v-60.423a6.369 6.369 0 0 0 -.843-3.222z",
    fill: "#d9ac80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.256 421.7h-234.108a24.566 24.566 0 0 0 0 49.132h388.887a24.566 24.566 0 0 0 0-49.132z",
    fill: "#a67e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.253 142.764q31.512-37 43.309-100.342l-71.623.413-84.939 99.929z",
    fill: "#cf312d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.562 42.422q-11.8 63.341-43.309 100.342h113.668c.034-1.7 1.373-82.8 1.909-100.76z",
    fill: "#d1d1d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.83 42c-.536 17.957-1.875 99.065-1.909 100.761h111.171c-21.008-24.668-35.67-58.913-43.535-101.14z",
    fill: "#cf312d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.557 41.624c7.865 42.227 22.527 76.472 43.535 101.14h115.75l-80.775-101.594z",
    fill: "#d1d1d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.842 142.764h-114.084v17.488.536a56.651 56.651 0 0 0 64.21 55.583c27.717-3.726 49.877-27.538 49.877-56.119z",
    fill: "#d1d1d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.133 216.878a56.794 56.794 0 0 0 56.622-56.09c0-.178 0-.357 0-.536v-17.488h-113.25v17.488.768a56.8 56.8 0 0 0 56.628 55.858z",
    fill: "#ff3c38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.88 216.878c30.483 0 56.193-25.462 56.62-55.858 0-.256 0-.512 0-.768v-17.488h-113.247v17.488q0 .3 0 .6a56.808 56.808 0 0 0 56.627 56.026z",
    fill: "#d1d1d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.627 216.878a56.8 56.8 0 0 0 56.623-56.023q0-.3 0-.6v-17.491h-113.25v17.488a56.792 56.792 0 0 0 56.627 56.626z",
    fill: "#ff3c38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.639 409.324a60.762 60.762 0 0 1 60.584-60.584h48.738a60.762 60.762 0 0 1 60.583 60.584v12.376h92.421v-47.12l-12.053-6.958-26.164-15.106a6.249 6.249 0 0 1 -3.2-5.541v-60.425a6.251 6.251 0 0 1 3.2-5.54l26.164-15.11 12.053-6.959v-42.57a56.651 56.651 0 0 1 -64.21-55.583 56.631 56.631 0 0 1 -113.255.232c-.427 30.4-26.137 55.858-56.62 55.858a56.808 56.808 0 0 1 -56.63-56.023 56.794 56.794 0 0 1 -56.625 56.022v204.823h85.014zm36.408-130.817a48.544 48.544 0 1 1 48.544 48.544 48.544 48.544 0 0 1 -48.544-48.544z",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.135 278.507a48.548 48.548 0 0 1 -44.044 48.338q2.223.206 4.5.206a48.544 48.544 0 0 0 0-97.088q-2.275 0-4.5.205a48.55 48.55 0 0 1 44.044 48.339z",
    fill: "#e28c73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorPortal);
export default __webpack_public_path__ + "static/media/vendor-portal.1fbdeeb9e67a2c23857a875ee10e0bb1.svg";
export { ForwardRef as ReactComponent };